export const SITES = {
    VRBO: 'vrbo',
    ABRITEL: 'abritel',
    HOMEAWAY_US: 'homeaway_us',
    HOMEAWAY_UK: 'homeaway_uk',
    HOMEAWAY_ES: 'homeaway_es',
    HOMEAWAY_PL: 'homeaway_pl',
    HOMEAWAY_DE: 'homeaway_de',
    HOMEAWAY_DK: 'homeaway_dk',
    HOMEAWAY_CA: 'homeaway_ca',
    HOMEAWAY_IT: 'homeaway_it',
    HOMEAWAY_AU: 'homeaway_au',
    HOMEAWAY_NZ: 'homeaway_nz'
};

export const isVrbo = (siteName) => siteName === SITES.VRBO;
